import type { ReactNode } from "react";
import estilos from "./Etiqueta.module.css";

export type TonoPildora = "neutro" | "transito" | "puerto" | "retirado" | "bien" | "alerta" | "error";
export type TonoChip = "neutro" | "alerta" | "bien" | "error";

/** Etiqueta de estado con punto de color (estado del embarque, de la factura). */
export function Pildora({ tono = "neutro", children }: { readonly tono?: TonoPildora; readonly children: ReactNode }) {
  return (
    <span className={[estilos.pildora, tono !== "neutro" && estilos[tono]].filter(Boolean).join(" ")}>{children}</span>
  );
}

/** Marca breve junto a un dato («Aviso», «+3 días vs. fecha original»). */
export function Chip({
  tono = "neutro",
  className,
  children,
}: {
  readonly tono?: TonoChip;
  readonly className?: string | undefined;
  readonly children: ReactNode;
}) {
  return (
    <span className={[estilos.chip, tono !== "neutro" && estilos[tono], className].filter(Boolean).join(" ")}>
      {children}
    </span>
  );
}
